var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2442 9.90036C10.2085 9.82656 10.151 9.76553 10.0795 9.72546C10.0081 9.68539 9.92595 9.66835 9.84439 9.67647C8.6539 9.84584 7.44162 9.5991 6.41202 8.97793C5.38242 8.35677 4.59884 7.39927 4.19353 6.26722C3.78832 5.13516 3.78617 3.89802 4.18764 2.76449C4.46651 1.97555 4.93294 1.26621 5.54689 0.697594C5.6338 0.61987 5.68244 0.507967 5.67994 0.391342C5.67744 0.27471 5.62416 0.164949 5.53404 0.0908921C5.44391 0.016826 5.32594 -0.0141396 5.21108 0.0060297C3.95323 0.177452 2.78158 0.74187 1.86347 1.61871C0.94535 2.49554 0.327797 3.63998 0.0988276 4.88865C-0.130142 6.13724 0.0410929 7.42644 0.5882 8.57186C1.1353 9.71739 2.03034 10.6608 3.1454 11.2675C4.26057 11.8742 5.53881 12.1131 6.79799 11.9502C8.05692 11.7872 9.23229 11.2307 10.1561 10.3601C10.2172 10.3025 10.2587 10.227 10.2744 10.1445C10.2902 10.0619 10.2797 9.97649 10.2442 9.90036Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.2998fa63aeec6aaa5d8099b7ae979d7d.svg";
export { ForwardRef as ReactComponent };